<template>
  <div class="kv-tabs-container">
    
    <div class="kv-tabs-scroll-area">
      <div class="kv-tabs" :class="{ 'kv-tabs-grow': grow }">
        <slot name="tabs"></slot>
      </div>
    </div>

    <div class="kv-tab-panels-container">
      <slot name="panels"></slot>
    </div>
  </div>
</template>

<script>
const TabsKey = 'kv-tabs';

export default {
  name: 'KvTabs',
  props: {
    value: { type: [String, Number], default: null },
    grow: { type: Boolean, default: false }
  },
  data() {
    return {
      activeTab: { value: this.value },
    };
  },
  watch: {
    value(newVal) { this.activeTab.value = newVal; },
    'activeTab.value': function (newVal) { this.$emit('input', newVal); },
  },
  provide() {
    return {
      [TabsKey]: {
        activeTab: this.activeTab,
        selectTab: this.selectTab,
      },
    };
  },
  methods: {
    selectTab(tabValue) { this.activeTab.value = tabValue; },
  },
};
</script>

<style scoped lang="less">
/* O container principal apenas segura o layout vertical */
.kv-tabs-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}

/* NOVO: Essa classe controla o Scroll APENAS do header */
.kv-tabs-scroll-area {
  width: 100%;
  overflow-x: auto; /* O scroll acontece aqui */
  
  /* Esconder scrollbar para estética (opcional) */
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

.kv-tabs {
  display: inline-flex; /* Padrão flex */
  min-width: 100%;      /* Garante que ocupe a tela toda se tiver pouco item */
  border-bottom: 1px solid #e0e0e0;

  &.kv-tabs-grow {
    /* inline-grid permite que este elemento fique MAIOR que a tela 
       (causando o scroll na div pai 'kv-tabs-scroll-area')
    */
    display: inline-grid; 
    
    /* Cria colunas automáticas */
    grid-auto-flow: column;
    
    /* Mágica: Todas as colunas terão tamanho igual (1fr),
       baseado no maior conteúdo */
    grid-auto-columns: 1fr;
  }
}

.kv-tab-panels-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* Garante que o painel não herde comportamentos estranhos */
  width: 100%; 
}
</style>